import { appAssetsCdnUrl } from '~/constants/environment';

const imageBase = `${appAssetsCdnUrl}/images/dealership/test-drive-center`;

export const testDriveCenterImages = {
  expertService: `${imageBase}/expert-service.jpg`,
  findItCube: `${imageBase}/find-it-cube.jpg`,
  findItDrive: `${imageBase}/find-it-drive.jpg`,
  findItPocket: `${imageBase}/find-it-pocket.jpg`,
  heroLot: `${imageBase}/hero-lot.jpg`,
  storefrontLot: `${imageBase}/storefront-lot.jpg`,
  topPickJeepGladiator: `${imageBase}/top-pick-jeep-gladiator.jpg`,
  topPickJeepGrandCherokee: `${imageBase}/top-pick-jeep-grand-cherokee.jpg`,
  topPickJeepWrangler: `${imageBase}/top-pick-jeep-wrangler.jpg`,
  topPickRam2500: `${imageBase}/top-pick-ram-2500.jpg`
};
